//Generated by AI, Needs to be reviewed
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ToggleProps {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
}

const Toggle: FC<ToggleProps> = ({ label, value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1.5 items-start">
      <label className="body-sm-regular text-(--font-heading) pr-3">{label}</label>
      <div className="bg-(--surface-secondary-low) flex gap-0.5 items-center justify-center p-1.5 rounded-3xl">
      <button
          type="button"
          onClick={() => onChange(true)}
          className={`px-6 py-2 rounded-3xl transition-colors ${
            value
              ? 'bg-(--surface-base) text-(--font-primary) body-sm-bold shadow-sm'
              : 'text-(--font-body-1) body-sm-regular'
          }`}
        >
          {t('yes')}
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`px-6 py-2 rounded-3xl body-sm-regular transition-colors ${
            !value
              ? 'bg-(--surface-base) text-(--font-body-1) body-sm-regular shadow-sm'
              : 'text-(--font-body-1) body-sm-regular'
          }`}
        >
          {t('no')}
        </button>
      </div>
    </div>
  );
};

export default Toggle;

